import { Box, Typography, Button, Divider, List, ListItem, ListItemText } from '@mui/material';
import * as theme from '../../theme'; // Assuming theme is exported from '../../theme'
import { useNavigate } from 'react-router'; // If navigation is needed, otherwise remove

// Import local images (placeholders; replace with actual local paths)
import logo from './logo.png'; // Logo (transparent) no Circle with Text (black).png
import thankYouImage from './thank-you-for-booking.png'; // art-d5fb9a36-7906-4ffe-b307-24b0434fdf62-8aecd7c4-774b-4ee1-9a2f-55710d5d0cd8.png
import plant from './plant.jpg';
import preparingImage from './preparing-for-your-session.png'; // art-aMDKzXsudY-b0a3c671-3a91-4b8d-8ce3-18b98e0b8ca9.png
import wavyDivider from './dividerwavy.png'; // dividerwavy_dbab9e34-13a3-4ae4-bf6a-450639725b86.png
import welcomeImage from './welcome.png'; // svg-IgHYKt1FaM-4055e0a5-6cd6-47fb-87e3-0f01f20eb681.png
import whatToExpectImage from './what-to-expect.png'; // art-7c8d0693-c611-4d6b-a0a3-0b78a020dfc0-629953c2-d820-4def-ac19-fe619bf636f2.png
import watchClientIntro from './watch-client-intro.png';
import locationImage from './location.jpg'; // RenuHealth-061_-_web_size.jpg
import urineInstructionsImage from './urine-sample-instructions.png'; // art-5HhjTkXAhs-dacace20-73b2-44a8-a082-29fbe9d5490d.png
import followInstagramImage from './follow-us-on-instagram.png'; // art-yq6xf7Mzg5-6faa5c57-9c2c-4b95-b499-bc676559d795.png
import renuHealthMnImage from './renuhealthmn.png'; // art-Sf7r0uVqtb-27743abe-615d-4868-8b2d-8c055849d92a.png
import renuWithBeccaImage from './renuwithbecca.png'; // art-V4lU09VYqy-b0f7280a-11a5-4b04-887f-fa0c06e077c5.png
import instagramIcon from './instagram-icon.png'; // usercontent.flodesk.com/assets/social/circle/000000/instagram.png
import youtubeIcon from './youtube-icon.png'; // usercontent.flodesk.com/assets/social/circle/000000/youtube.png

export default function AppointmentDetails() {
  const navigate = useNavigate(); // If needed for navigation, e.g., back button

  return (
    <Box sx={{ ...theme.Container.basicWide, marginTop: 2, padding: { xs: 2, md: 4 }, backgroundColor: '#ffffff', color: '#333333' }}>
      {/* Logo */}
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 0 }}>
        <img src={logo} alt="TruBalance Bioenergetics Logo" style={{ maxWidth: '143px', height: 'auto' }} />
      </Box>

      <Divider sx={{ my: 2, borderColor: '#373739' }} />

      {/* Thank You Section */}
      <Box sx={{ textAlign: 'center', mb: 0 }}>
        <img src={thankYouImage} alt="Thank you for booking!" style={{ maxWidth: '100%', height: 'auto' }} />
      </Box>

      <Box sx={{ textAlign: 'center', mb: 4, position: 'relative' }}>
        <div className="plant-container">
          <img src={plant} alt="Session Details" className="plant-img" />
          <div className="overlay">
            <div className="location-title">Location</div>
            <div className="address">10800 Old County Rd 15, Plymouth, MN 55441</div>
            <div className="subaddress">(In the lower level of Revolution Chiropractic Wellness Center)</div>
            <div className="notes-title">Special Notes</div>
            <div className="note">- Have a light meal or snack within 2 hours prior to your appointment.</div>
            <div className="note">- Please come perfume/scent free</div>
          </div>
        </div>
      </Box>

      {/* Preparing for Your Session */}
      <Box sx={{ backgroundColor: '#ececec', p: 0, mb: 0 }}>
        <img src={preparingImage} alt="Preparing for your session" style={{ maxWidth: '100%', height: 'auto' }} />
      </Box>

      <Box sx={{ backgroundColor: '#d7d7d7', p: 3, mb: 0 }}>
        <div style={{ fontFamily: 'Optima', fontSize: 20, textTransform: 'uppercase', marginBottom: 10 }}>1. Complete <b>Intake Forms</b> <span style={{ fontSize: 15, fontStyle: 'italic' }}>(link in email)</span></div>
        <div style={{ fontFamily: 'Optima', fontSize: 20, textTransform: 'uppercase', marginBottom: 10 }}>2. Complete <b>Consent Forms</b> <span style={{ fontSize: 15, fontStyle: 'italic' }}>(In Square)</span></div>
        <div style={{ fontFamily: 'Optima', fontSize: 20, textTransform: 'uppercase', marginBottom: 10 }}>3. Email <b>Photos</b> <span style={{ fontSize: 15 }}> - Face, Tongue & Nails (<a href="https://www.renuhealthmn.com/welcome-email#photos" target="_blank">more info</a>)</span></div>
        <div style={{ fontFamily: 'Optima', fontSize: 20, textTransform: 'uppercase' }}>4. Gather <b>Items</b> to Bring ↓</div>
      </Box>

      <Box sx={{ backgroundColor: theme.Colors.GrayDark, color: theme.Colors.White, p: 3, mb: 0 }}>
        <List disablePadding>
          <ListItem disablePadding>
            <ListItemText primary="- URINE SAMPLE*" primaryTypographyProps={{ fontFamily: 'Optima', fontWeight: 'bold', fontSize: '16px' }} />
          </ListItem>
          <ListItem disablePadding>
            <ListItemText primary="- ITEMS FOR TESTING" primaryTypographyProps={{ fontFamily: 'Optima', fontWeight: 'bold', fontSize: '16px' }} />
          </ListItem>
          <ListItem disablePadding sx={{ pl: 4 }}>
            <ListItemText primary="- Supplements + Medications" primaryTypographyProps={{ fontFamily: 'Montserrat', fontSize: '15px' }} />
          </ListItem>
          <ListItem disablePadding sx={{ pl: 4 }}>
            <ListItemText primary="- Protein Powders" primaryTypographyProps={{ fontFamily: 'Montserrat', fontSize: '15px' }} />
          </ListItem>
          <ListItem disablePadding sx={{ pl: 4 }}>
            <ListItemText primary="- Collagen" primaryTypographyProps={{ fontFamily: 'Montserrat', fontSize: '15px' }} />
          </ListItem>
          <ListItem disablePadding sx={{ pl: 4 }}>
            <ListItemText primary="- Bone Broths" primaryTypographyProps={{ fontFamily: 'Montserrat', fontSize: '15px' }} />
          </ListItem>
          <ListItem disablePadding sx={{ pl: 4 }}>
            <ListItemText primary="- Sample of Tap + Filtered Drinking Water" primaryTypographyProps={{ fontFamily: 'Montserrat', fontSize: '15px' }} />
          </ListItem>
          <ListItem disablePadding sx={{ pl: 4 }}>
            <ListItemText primary="- Pet Fur Sample (if you have any)" primaryTypographyProps={{ fontFamily: 'Montserrat', fontSize: '15px' }} />
          </ListItem>
          <ListItem disablePadding sx={{ pl: 4 }}>
            <ListItemText primary="- Topical creams/products" primaryTypographyProps={{ fontFamily: 'Montserrat', fontSize: '15px' }} />
          </ListItem>
          <ListItem disablePadding sx={{ pl: 4 }}>
            <ListItemText primary="- Anything else you take daily" primaryTypographyProps={{ fontFamily: 'Montserrat', fontSize: '15px' }} />
          </ListItem>
        </List>
      </Box>

      <img src={wavyDivider} alt="Divider" style={{ width: '100%', height: 'auto' }} />

      <Box sx={{ textAlign: 'center', mb: 0 }}>
        <img src={watchClientIntro} alt="Watch Client Intro" style={{ maxWidth: '100%', height: 'auto' }} />
      </Box>

      {/* Watch Client Intro */}
      <Box sx={{ textAlign: 'center', my: 0 }}>
        <a href="https://www.youtube.com/watch?v=IhsQ6uar3BA&feature=youtu.be" target="_blank"><img src={welcomeImage} alt="WELCOME" style={{ maxWidth: '100%', height: 'auto' }} /></a>
      </Box>

      <Box sx={{ textAlign: 'center', mb: 2, my: 2 }}>
        <Button 
          variant="outlined" 
          sx={{ borderColor: '#d7d7d7', color: '#000000', borderWidth: 2, borderRadius: 0, px: 2, py: 1 }}
          onClick={() => { window.open('https://www.renuhealthmn.com/welcome-email#expect', '_blank') }}
        >
          WHAT TO EXPECT
        </Button>
      </Box>

      <img src={wavyDivider} alt="Divider" style={{ width: '100%', height: 'auto' }} />

      {/* We Look Forward Section */}
      <Box sx={{ textAlign: 'center', mb: 0 }}>
        <img src={whatToExpectImage} alt="We Look Forward to Meeting you & Supporting your Health Journey!" style={{ maxWidth: '100%', height: 'auto' }} />
      </Box>

      <img src={locationImage} alt="Location Image" style={{ width: '100%', height: 'auto' }} />

      {/* Cancellation Policy */}
      <Box sx={{ backgroundColor: '#ececec', p: 2, textAlign: 'center', mb: 2 }}>
        <Typography variant="body1" sx={{ fontFamily: 'Optima', fontStyle: 'italic', fontWeight: 'bold', fontSize: '18px' }}>
          IF YOU NEED TO CANCEL:
        </Typography>
        <Typography variant="body1" sx={{ fontFamily: 'Optima', fontSize: '16px', marginTop: '5px' }}>
          Contact us no later than 48 hours prior to your session via <a href="mailto:hello@renuhealthmn.com">hello@renuhealthmn.com</a>
        </Typography>
        <Typography variant="body2" sx={{ fontFamily: 'Optima', fontSize: '13px', marginTop: '5px' }}>
          Failure to cancel more than <b>48 hours</b> before appointment will result in cancellation fee.
        </Typography>
      </Box>

      <img src={wavyDivider} alt="Divider" style={{ width: '100%', height: 'auto' }} />

      {/* Urine Sample Instructions */}
      <Box sx={{ textAlign: 'center', mb: 0 }}>
        <img src={urineInstructionsImage} alt="*URINE SAMPLE INSTRUCTIONS" style={{ maxWidth: '100%', height: 'auto' }} />
      </Box>

      <Box sx={{ p: 2, textAlign: 'center', mb: 2 }}>
        <Typography variant="body2" sx={{ fontFamily: 'Montserrat', fontSize: '12px' }}>
          You will need to gather a urine sample. Complete a 12 hour fast with no food/liquids. Then take a urine sample in a clear jar, seal it with a lid and take a picture of the side and underneath. If you go to the bathroom in the middle of the night we do not need that sample, just the one in the morning. It is preferred if you bring the jar with you. Collect sample in a clear jar, seal it with a lid and take a picture of the side and underneath. If you go to the bathroom in the middle of the night we do not need that sample, just the one in the morning. It is preferred if you bring the jar with you.
        </Typography>
      </Box>

      <Divider sx={{ width: '300px', mx: 'auto', borderColor: '#000000' }} />

      {/* Follow on Instagram */}
      <Box sx={{ textAlign: 'center', my: 0, marginTop: '10px' }}>
        <img src={followInstagramImage} alt="FOLLOW us on INSTAGRAM" style={{ maxWidth: '100%', height: 'auto' }} />
      </Box>

      <Box sx={{ textAlign: 'center', mb: 0 }}>
        <img src={renuHealthMnImage} alt="@RENUHEALTHMN" style={{ maxWidth: '100%', height: 'auto' }} />
      </Box>

      <Box sx={{ textAlign: 'center', mb: 0 }}>
        <img src={renuWithBeccaImage} alt="@RENUwithBecca" style={{ maxWidth: '100%', height: 'auto' }} />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 2 }}>
        <a href="https://www.instagram.com/renuwithbecca" target="_blank" rel="noopener noreferrer">
          <img src={instagramIcon} alt="Instagram" style={{ width: '32px', height: '32px' }} />
        </a>
        <a href="https://www.youtube.com/channel/UCHt3d6TIUDegrl9DakUTtSg" target="_blank" rel="noopener noreferrer">
          <img src={youtubeIcon} alt="Youtube" style={{ width: '32px', height: '32px' }} />
        </a>
      </Box>

      {/* Questions Section */}
      <Box sx={{ textAlign: 'center', mb: 2 }}>
        <Typography variant="body1" sx={{ fontSize: '14px' }}>
          Questions? Please email: <a href="mailto:hello@renuhealthmn.com">hello@renuhealthmn.com</a>
        </Typography>
      </Box>

      {/* Address */}
      <Box sx={{ textAlign: 'center', mb: 2 }}>
        <Typography variant="body2" sx={{ fontSize: '11px', color: '#797979' }}>
          10800 Old County Road 15<br />
          Plymouth, Minnesota 55441, United States
        </Typography>
      </Box>
    </Box>
  );
}